import PropTypes from 'prop-types';
import React from 'react';
import Moment from 'moment';

import Spacer from '../../components/common/spacer/Spacer';
import Rating from '../../components/derived/rating/Rating';

require('./style.scss');

const ReviewCard = props =>

  <div className="review-body">
    <div className="user-image">{props.avatar}</div>
    <div>
      <h4>{props.username || 'm.Paani User'}</h4>
      <Spacer size={0.5} />
      <Rating
        rating={props.rating}
        backgroundColor="#F0C419"
        color="white"
      />
      <Spacer size={1.5} />
      {props.review ?
        <div>
          <h5>{props.review}</h5>
          {props.showReply && props.reply ? props.reply : ''}
        </div> : ''}
    </div>
  </div>;

ReviewCard.Reply = props =>
  <div className="review-reply">
    <div className="reply">{props.reply}</div>
    <Spacer size={1} />
    <div className="username">
      <strong>{props.username}</strong>
    </div>
  </div>;

ReviewCard.Reply.propTypes = {
  reply: PropTypes.string,
  username: PropTypes.string,
};

ReviewCard.propTypes = {
  avatar: PropTypes.node,
  createdAt: PropTypes.instanceOf(Moment),
  rating: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  reply: PropTypes.element,
  review: PropTypes.string,
  showReply: PropTypes.bool,
  username: PropTypes.string,
};

module.exports = ReviewCard;



// WEBPACK FOOTER //
// ./app/app-utils/card/ReviewCard.jsx